import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ProjectModel } from '../models/project.model';
import { ProjectService } from './project.service';
import {
  getEffectiveSkidConfigurationParts,
  getProjectSkidConfigurationParts,
  SkidConfigurationParts
} from '../utils/skid-configuration.utils';

@Injectable({
  providedIn: 'root'
})
export class EffectiveSkidConfigurationService {
  private cache = new Map<number, Observable<SkidConfigurationParts>>();

  constructor(private projectService: ProjectService) {}

  getEffectiveParts(project: ProjectModel | null | undefined): Observable<SkidConfigurationParts> {
    if (!project?.projectId) {
      return of(getProjectSkidConfigurationParts(project));
    }

    const projectId = project.projectId;
    const cached = this.cache.get(projectId);
    if (cached) {
      return cached;
    }

    // Card detail enrichment must not keep the page-level loading overlay visible.
    const request$ = this.projectService.getProjectBlockScheduleWithoutSpinner(projectId).pipe(
      map(blocks => getEffectiveSkidConfigurationParts(project, blocks)),
      catchError(() => of(getProjectSkidConfigurationParts(project))),
      shareReplay(1)
    );

    this.cache.set(projectId, request$);
    return request$;
  }

  clear(projectId?: number): void {
    if (typeof projectId === 'number') {
      this.cache.delete(projectId);
      return;
    }

    this.cache.clear();
  }
}
